import { IStreamStoreSegment } from './stream.interface';

export const streamStoreSelector = (state: IStreamStoreSegment) => state.stream;
